<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">#</th>
        <th scope="col" class="border-0">Nome</th>
        <th scope="col" class="border-0">Cliente</th>
        <th scope="col" class="border-0">Telefone</th>
        <th scope="col" class="border-0">Inicio</th>
        <th scope="col" class="border-0">Fim</th>
        <th scope="col" class="border-0">Status</th>
        <th scope="col" class="border-0" v-if="!isCustomer">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in projects" :key="index">
        <td>{{ row.id }}</td>
        <td class="td-4 link">
          <d-link :to="{ name: 'admin-project-edit', params: { projectId: row.id, page: 1 }}">{{ row.label }}</d-link>
        </td>
        <td class="td-3">{{ (row.customer) ? row.customer.name : '' }}</td>
        <td class="td-2">{{ (row.customer) ? row.customer.phone : '' }}</td>
        <td class="td-2">{{ row.f_started_at }}</td>
        <td class="td-2">{{ row.f_finished_at }}</td>
        <td class="td-2">
          <d-select
            v-model="row.status_id"
            value-field="id"
            text-field="name"
            @change="changeStatus($event, row)"
            :disabled="isCustomer"
          >
            <option value="">Selecione um status</option>
            <option v-for="(status, index) in row.project_status" :disabled="status.pivot.finished_at" :key="index" :value="status.id" >{{status.name}}</option>
          </d-select>
        </td>
        <td class="td-2" v-if="!isCustomer">
          <project-buttons :project="row"></project-buttons>
        </td>
      </tr>
      <tr v-if="projects.length === 0">
        <td colspan="8" class="no-content">Ainda não tem nenhuma obra cadastrado.</td>
      </tr>
    </tbody>
    <confirmation-modal
      :cancel="close"
      :confirm="callback"
      :title="confirmation[type].title"
      :message="confirmation[type].message"/>
  </table>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import ProjectButtons from './ProjectButtons.vue';
import ProjectActions from './ProjectActions';
import { OPTIONS_CONFIRMATION_MODAL, _OPEN_CONFIRMATION_ } from './ProjectModel';

export default {
  name: 'project-table',
  mixins: [ProjectActions],
  components: {
    ProjectButtons,
    ConfirmationModal,
  },
  props: {
    projects: {
      type: Array,
    },
  },
  data() {
    return {
      type: 'delete',
      isCustomer: false,
      confirmation: OPTIONS_CONFIRMATION_MODAL,
      selectProject: null,
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'checkIsCustomer',
    ]),
    callback() {
      const { callback } = this.confirmation[this.type];
      this[callback]();
    },
    checkUser() {
      this.checkIsCustomer().then(response => {
        this.isCustomer = response;
      });
    },
    changeStatus(event, row) {
      setTimeout(() => {
        this.type = 'status';
        this.selectProject = row;
        this.setToggle({ type: 'confirm_modal', bool: true });
        return true;
      }, 10);
    },
  },
  mounted() {
    this.checkUser();
    Events.$on(_OPEN_CONFIRMATION_, ({ project, type }) => {
      this.selectProject = project;
      this.type = type;
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  color: $primary;
  a {
    cursor: pointer;
  }
}

.td {
  &-2 {
    min-width: 140px;
  }
  &-3 {
    min-width: 140px;
  }
  &-4 {
    min-width: 200px;
  }
}
</style>
